















import Vue from "vue";
export default Vue.extend({
  props: {
    radioGroupParam: {
      type: Object,
      default: Object,
    },
    radioGroupKey: {
      type: String,
      default: String,
    },
  },
  data() {
    return {
      checkType: "",
    };
  },
  watch: {
    checkType() {
      this.radioGroupParam[this.radioGroupKey] = this.checkType;
    },
    OptsParam: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.checkType = this.radioGroupParam[this.radioGroupKey];
    },
  },
});
